import React from "react"
import { graphql } from "gatsby"
import Box from "../atoms/Box"
import styled from "styled-components"

const VerticalBox = styled(Box)`
  text-orientation: sideways;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  justify-content: ${props =>
    props.vTextPosition === "top"
      ? "start"
      : props.vTextPosition === "center"
      ? "center"
      : props.vTextPosition === "bottom"
      ? "end"
      : "end"};
`
const Rotate = styled.p`
  transform: rotate(180deg);
  writing-mode: vertical-rl;
`
const VerticalText = ({ hideOnMobile, alignment, text, position, ...rest }) => {
  return (
    <Box
      width={"100%"}
      height={"100%"}
      display="flex"
      position="absolute"
      justifyContent={
        position === "left"
          ? "flex-start"
          : position === "right"
          ? "flex-end"
          : "flex-start"
      }
      {...rest}
    >
      <Box
        height="100%"
        zIndex={20}
        color={"text"}
        p={6}
        display={{
          _: hideOnMobile === "on" ? "none" : "block",
          lg: "block",
          // md: verticalText?.hideOnMobile === "on" ? "none" : "block",
        }}
      >
        <VerticalBox vTextPosition={alignment}>
          <Rotate>{text}</Rotate>
        </VerticalBox>
      </Box>
    </Box>
  )
}

export default VerticalText

export const query = graphql`
  fragment VerticalText on STRAPI__COMPONENT_ATOMS_VERTICAL_TEXT {
    text
    position
    alignment
    hideOnMobile
  }
`
